/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { MutableRefObject, useCallback, useEffect } from 'react';

function useOutsideClick(ref: MutableRefObject<HTMLElement | null>, callback: () => void) {
  const handleClick = useCallback(
    (event) => {
      // Check if the clicked target is outside the referenced element
      if (ref.current && !ref.current.contains(event.target) && typeof callback === 'function') {
        callback();
      }
    },
    [ref, callback],
  );

  useEffect(() => {
    // Add event listener for clicks
    document.addEventListener('mouseup', handleClick);
    document.addEventListener('touchend', handleClick);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('mouseup', handleClick);
      document.removeEventListener('touchend', handleClick);
    };
  }, [handleClick]);
}

export default useOutsideClick;
